<div #printArea class="ahorro-fiscal" [formGroup]="form">
  <div class="ahorro-fiscal__title">
    {{ 'PYMES.AHORRO-FISCAL.TITLE' | translate }}
  </div>

  <section class="calculator-section">
    <div class="section-heading">
      <span class="section-heading__icon" aria-hidden="true">
        <span class="section-heading__check">✓</span>
      </span>

      <h2 class="section-heading__title">
        {{ 'PYMES.AHORRO-FISCAL.AHORRO-EMPLEADO' | translate }}
      </h2>
    </div>

    <p class="section-description">
      {{ 'PYMES.AHORRO-FISCAL.DESCRIPTION-EMPLEADO' | translate }}
    </p>

    <div class="comparison-table comparison-table--employee">
      <div class="comparison-table__header comparison-table__header--spacer"></div>

      <div class="comparison-table__header">
        {{ 'PYMES.AHORRO-FISCAL.SIN-RETRIBUCION-FLEXIBLE' | translate }}
      </div>

      <div class="comparison-table__header">
        {{ 'PYMES.AHORRO-FISCAL.CON-RETRIBUCION-FLEXIBLE' | translate }}
      </div>

      <ng-container *ngFor="let row of employeeRows; trackBy: trackByLabel">
        <div class="comparison-table__label">
          {{ row.etiqueta | translate }}
        </div>

        <div class="comparison-table__value" [class.comparison-table__value--editable]="row.controlSinRetribucion"
          [class.comparison-table__value--readonly]="!row.controlSinRetribucion"
          [class.comparison-table__value--empty]="!row.sinRetribucionFlexible && !row.controlSinRetribucion">
          <ng-container *ngIf="row.controlSinRetribucion; else textoSinRetribucionFlexible">
            <span class="table-cell-value">
              <input class="table-input" type="text" inputmode="decimal" [formControlName]="row.controlSinRetribucion"
                (focus)="onEditableInputFocus(row.controlSinRetribucion, row.sufijoSinRetribucion)"
                (blur)="onEditableInputBlur(row.controlSinRetribucion, row.sufijoSinRetribucion)" />

              <span class="table-input-suffix" *ngIf="row.sufijoSinRetribucion">
                {{ row.sufijoSinRetribucion }}
              </span>
            </span>
          </ng-container>

          <ng-template #textoSinRetribucionFlexible>
            <span class="table-cell-value">
              {{ row.sinRetribucionFlexible }}
            </span>
          </ng-template>
        </div>

        <div class="comparison-table__value" [class.comparison-table__value--editable]="row.controlConRetribucion"
          [class.comparison-table__value--readonly]="!row.controlConRetribucion && !row.destacado"
          [class.comparison-table__value--highlight]="row.destacado"
          [class.comparison-table__value--empty]="!row.conRetribucionFlexible && !row.controlConRetribucion">
          <ng-container *ngIf="row.controlConRetribucion; else textoConRetribucionFlexible">
            <span class="table-cell-value">
              <input class="table-input" type="text" inputmode="decimal" [formControlName]="row.controlConRetribucion"
                (focus)="onEditableInputFocus(row.controlConRetribucion, row.sufijoConRetribucion)"
                (blur)="onEditableInputBlur(row.controlConRetribucion, row.sufijoConRetribucion)" />

              <span class="table-input-suffix" *ngIf="row.sufijoConRetribucion">
                {{ row.sufijoConRetribucion }}
              </span>
            </span>
          </ng-container>

          <ng-template #textoConRetribucionFlexible>
            <span class="table-cell-value">
              {{ row.conRetribucionFlexible }}
            </span>
          </ng-template>
        </div>
      </ng-container>
    </div>

    <div>
      <div class="orange">
        {{ 'PYMES.AHORRO-FISCAL.TEXTO-INFORMATIVO-EMPLEADO' | translate }}
      </div>

      <div class="subscripts">
        <span class="small-text">
          {{ 'PYMES.AHORRO-FISCAL.TEXTO-EMPLEADO' | translate }}
        </span>

        <span class="small-text">
          {{ 'PYMES.AHORRO-FISCAL.FIRST-INFO-TEXT' | translate }}
        </span>
      </div>
    </div>
  </section>

  <section class="calculator-section calculator-section--company">
    <div class="section-heading">
      <span class="section-heading__icon" aria-hidden="true">
        <span class="section-heading__check">✓</span>
      </span>

      <h2 class="section-heading__title">
        {{ 'PYMES.AHORRO-FISCAL.AHORRO-EMPRESA' | translate }}
      </h2>
    </div>

    <p class="section-description">
      {{ 'PYMES.AHORRO-FISCAL.DESCRIPTION-EMPRESA' | translate }}
    </p>

    <div class="simple-table">
      <ng-container *ngFor="let row of companyRows; trackBy: trackByLabel">
        <div class="simple-table__label">
          {{ row.etiqueta | translate }}
        </div>

        <div class="simple-table__value" [class.simple-table__value--editable]="row.control"
          [class.simple-table__value--readonly]="!row.control && !row.destacado"
          [class.simple-table__value--highlight]="row.destacado">
          <ng-container *ngIf="row.control; else textoValorEmpresa">
            <span class="table-cell-value">
              <input class="table-input" type="text" inputmode="decimal" [formControlName]="row.control"
                (focus)="onEditableInputFocus(row.control, row.sufijo)"
                (blur)="onEditableInputBlur(row.control, row.sufijo)" />

              <span class="table-input-suffix" *ngIf="row.sufijo">
                {{ row.sufijo }}
              </span>
            </span>
          </ng-container>

          <ng-template #textoValorEmpresa>
            <span class="table-cell-value">
              {{ row.valor }}
            </span>
          </ng-template>
        </div>
      </ng-container>
    </div>

    <div>
      <div class="orange">
        {{ 'PYMES.AHORRO-FISCAL.TEXTO-INFORMATIVO-COMPANIA' | translate }}
      </div>

      <div class="subscripts">
        <span class="small-text">
          {{ 'PYMES.AHORRO-FISCAL.TEXTO-COMPANIA' | translate }}
        </span>

        <span class="small-text">
          {{ 'PYMES.AHORRO-FISCAL.SECOND-INFO-TEXT' | translate }}
        </span>
      </div>
    </div>
  </section>
  <section class="mt-4 no-print">
    <div class="float-right">
      <button ca-button class="no-print ca-btn-icon__container ml-2" type="button" (click)="onImprimir()">
        {{ 'IMPRIMIR' | translate }}
      </button>
    </div>
  </section>
  <div class="small-text">
    {{ 'PYMES.AHORRO-FISCAL.INFO-CALCULADORA' | translate }}
  </div>
</div>